<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm12 md10 lg6 xl6>
      <MessageBox
        id="boxSinEmpresas"
        :title="
          NRC && NRC !== 'NO VALIDO' && String(NRC).substring(55, 57) === '00'
            ? $t('message.aeat.detalleOK')
            : $t('message.aeat.detalleError')
        "
        :type="
          NRC && NRC !== 'NO VALIDO' && String(NRC).substring(55, 57) === '00' ? 'success' : 'error'
        "
      >
        <v-container grid-list-md text-xs-center v-if="NRC === 'NO VALIDO'">
          <v-layout row wrap>
            <v-flex text-xs-left xs12>
              <v-card style="font-weight: bold;" flat
                >El pago de la Tasa no se ha relizado, compruebe la información enviada a
                AEAT</v-card
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs12>
              <v-card style="font-weight: bold;" flat>NRC:</v-card>
              <v-card flat>{{ String(NRC) }}</v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container grid-list-md text-xs-center v-else-if="String(NRC).substring(55, 57) === '00'">
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <v-card style="font-weight: bold;" flat>Respuesta AEAT: </v-card>
            </v-flex>
            <v-flex xs6>
              <v-card flat>{{
                $t('message.aeat.return.RET' + String(NRC).substring(55, 57))
              }}</v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <v-card style="font-weight: bold;" flat>Nif:</v-card>
            </v-flex>
            <v-flex xs6>
              <v-card flat>{{ String(NRC).substring(0, 9) }}</v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <v-card style="font-weight: bold;" flat>Importe:</v-card>
            </v-flex>
            <v-flex xs6>
              <v-card flat>{{
                (String(NRC)
                  .substring(9, 19)
                  .replace(/\b0+/g, '').length === 0
                  ? '0'
                  : String(NRC)
                      .substring(9, 19)
                      .replace(/\b0+/g, '')) +
                  ',' +
                  String(NRC).substring(19, 21)
              }}</v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <v-card style="font-weight: bold;" flat>Fecha:</v-card>
            </v-flex>
            <v-flex xs6>
              <v-card flat>{{
                String(NRC)
                  .substring(21, 29)
                  .substring(6, 8) +
                  '/' +
                  String(NRC)
                    .substring(21, 29)
                    .substring(4, 6) +
                  '/' +
                  String(NRC)
                    .substring(21, 29)
                    .substring(0, 4)
              }}</v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <v-card style="font-weight: bold;" flat>Entidad:</v-card>
            </v-flex>
            <v-flex xs6>
              <v-card flat>{{ String(NRC).substring(29, 33) }}</v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <v-card style="font-weight: bold;" flat>Justificante:</v-card>
            </v-flex>
            <v-flex xs6>
              <v-card flat>{{ String(NRC).substring(33, 46) }}</v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <v-card style="font-weight: bold;" flat>NRC:</v-card>
            </v-flex>
            <v-flex xs6>
              <v-card flat>{{ String(NRC).substring(33, 55) }}</v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container grid-list-md text-xs-center v-else>
          <v-layout row wrap>
            <v-flex text-xs-left xs12>
              <v-card style="font-weight: bold;" flat
                >El pago de la Tasa no se ha relizado, compruebe la información enviada a
                AEAT</v-card
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs12>
              <v-card style="font-weight: bold;" flat>Respuesta AEAT:</v-card>
              <v-card flat>{{
                $t('message.aeat.return.RET' + String(NRC).substring(55, 57))
              }}</v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs12>
              <v-card style="font-weight: bold;" flat>NRC:</v-card>
              <v-card flat>{{ String(NRC) }}</v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <template slot="actions"
          ><v-spacer></v-spacer>
          <Boton id="btnIrInicfio" tipo="danger" :onclick="clickHandler">{{
            $t('message.aeat.volver')
          }}</Boton>
        </template>
      </MessageBox>
    </v-flex>
  </v-layout>
</template>

<script>
import { Boton, MessageBox } from '@/components';
export default {
  name: 'infopago',
  props: {
    NRC: {
      type: String,
      required: true
    }
  },
  methods: {
    clickHandler() {
      this.$router.push({ name: 'tasasIndex' });
    }
  },
  components: {
    Boton,
    MessageBox
  }
};
</script>
